import { ClassNames } from '@emotion/core';
import MuiTextField, { FilledTextFieldProps } from '@mui/material/TextField';
import React from 'react';

export type TextFieldSize = 'small' | 'medium';

export interface TextFieldProps extends Omit<FilledTextFieldProps, 'variant'> {
  size: TextFieldSize;
}

function TextField({ size, InputProps, ...rest }: TextFieldProps) {
  return (
    <ClassNames>
      {({ css }) => (
        <MuiTextField
          variant="filled"
          InputProps={{
            ...InputProps,
            disableUnderline: true,
            classes:
              size === 'small'
                ? {
                    input: css`
                      height: 58px;
                    `,
                  }
                : undefined,
          }}
          InputLabelProps={{
            classes:
              size === 'small'
                ? {
                    root: css`
                      transform: translate(16px, 21px) scale(1);
                    `,
                  }
                : undefined,
          }}
          {...rest}
        />
      )}
    </ClassNames>
  );
}

TextField.defaultProps = {
  size: 'medium',
};

export default TextField;
